import * as React from "react";
import { styled, css } from "@lib/components";

const Content = styled("div")`
  padding: 20px;
  margin: 0 auto;
  margin-top: calc(${({ theme }) => theme.top_nav.height + 30}px + var(--cw-safe-top, 0px));
  margin-bottom: calc(${({ theme }) => theme.top_nav.height + 5}px + var(--cw-safe-bottom, 0px));
  width: 100%;
  max-width: ${({ theme }) => theme.content_width.md}px;

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const LayoutDashboardComponents = {
	Content,
};
